/* Bilmedie lookup - API-driven product matching via backend vehicle metafields */

const __HOST__ = (location.hostname || '').toLowerCase();

const IS_SE = __HOST__.endsWith('.se');
const IS_NO = __HOST__.endsWith('.no');
const IS_NL = __HOST__.endsWith('.nl');
const IS_PL = __HOST__.endsWith('.pl') || __HOST__.includes('carmedia24.pl');
const IS_FR = __HOST__.endsWith('.fr');
const IS_SI = __HOST__.endsWith('.si');
const IS_SK = __HOST__.endsWith('.sk');
const IS_EN = __HOST__.includes('carmediaeurope.com');
const IS_BG = __HOST__.endsWith('.bg');
const IS_GR = __HOST__.endsWith('.gr') || __HOST__.includes('carmedia24.gr');
const IS_ES = __HOST__.endsWith('.es');
const IS_PT = __HOST__.endsWith('.pt');
const IS_IT = __HOST__.endsWith('.it');
const IS_FI = __HOST__.endsWith('.fi');
const IS_HU = __HOST__.endsWith('.hu');
const IS_AT = __HOST__.endsWith('.at');

const I18N = IS_SE
  ? {
      labelMake: 'Märke',
      labelModel: 'Modell',
      loading: 'Hämtar produkter…',
      enterPlate: 'Ange ett registreringsnummer.',
      lookupError: 'Fel vid uppslagning av registreringsnummer.',
      countryUnsupported: 'Landet stöds inte ännu.',
      noVehicle: 'Ingen fordonsdata hittades.',
      unknown: 'Okänd',
      usingCache: 'Visar resultat från cache på grund av API-fel.',
      resultsFor: 'Resultat för',
      foundVehicle: 'Bil hittad'
    }


      : IS_NO
    ? {
        labelMake: 'Merke',
        labelModel: 'Modell',
        loading: 'Henter produkter…',
        enterPlate: 'Skriv inn et registreringsnummer.',
        lookupError: 'Feil ved oppslag av registreringsnummer.',
        countryUnsupported: 'Landet støttes ikke ennå.',
        noVehicle: 'Ingen kjøretøydata funnet.',
        unknown: 'Ukjent',
        usingCache: 'Viser bufrede resultater på grunn av API-feil.',
        resultsFor: 'Resultater for',
        foundVehicle: 'Bil funnet'
      }
  


  : IS_NL
    ? {
        labelMake: 'Merk',
        labelModel: 'Model',
        loading: 'Producten ophalen…',
        enterPlate: 'Voer een kenteken in.',
        lookupError: 'Fout bij het opzoeken van het kenteken.',
        countryUnsupported: 'Dit land wordt nog niet ondersteund.',
        noVehicle: 'Geen voertuiggegevens gevonden.',
        unknown: 'Onbekend',
        usingCache: 'Resultaten uit cache weergegeven wegens een API-fout.',
        resultsFor: 'Resultaten voor',
        foundVehicle: 'Voertuig gevonden'
      }
    : IS_PL
      ? {
          labelMake: 'Marka',
          labelModel: 'Model',
          loading: 'Pobieranie produktów…',
          enterPlate: 'Wpisz numer rejestracyjny.',
          lookupError: 'Błąd podczas sprawdzania numeru rejestracyjnego.',
          countryUnsupported: 'Ten kraj nie jest jeszcze obsługiwany.',
          noVehicle: 'Nie znaleziono danych pojazdu.',
          unknown: 'Nieznany',
          usingCache: 'Pokazujemy wyniki z pamięci podręcznej z powodu błędu API.',
          resultsFor: 'Wyniki dla',
          foundVehicle: 'Znaleziono pojazd'
        }
      : IS_FR
        ? {
            labelMake: 'Marque',
            labelModel: 'Modèle',
            loading: 'Chargement des produits…',
            enterPlate: 'Saisissez une plaque d’immatriculation.',
            lookupError: 'Erreur lors de la recherche de la plaque d’immatriculation.',
            countryUnsupported: 'Ce pays n’est pas encore pris en charge.',
            noVehicle: 'Aucune donnée véhicule trouvée.',
            unknown: 'Inconnu',
            usingCache: 'Affichage des résultats en cache en raison d’une erreur API.',
            resultsFor: 'Résultats pour',
            foundVehicle: 'Véhicule trouvé'
          }
        : IS_SI
          ? {
              labelMake: 'Znamka',
              labelModel: 'Model',
              loading: 'Pridobivanje izdelkov…',
              enterPlate: 'Vnesite registrsko številko.',
              lookupError: 'Napaka pri iskanju registrske številke.',
              countryUnsupported: 'Ta država še ni podprta.',
              noVehicle: 'Podatki o vozilu niso bili najdeni.',
              unknown: 'Neznano',
              usingCache: 'Prikazujemo rezultate iz predpomnilnika zaradi napake API.',
              resultsFor: 'Rezultati za',
              foundVehicle: 'Vozilo najdeno'
            }
          : IS_SK
            ? {
                labelMake: 'Značka',
                labelModel: 'Model',
                loading: 'Načítavajú sa produkty…',
                enterPlate: 'Zadajte evidenčné číslo vozidla.',
                lookupError: 'Chyba pri vyhľadávaní evidenčného čísla.',
                countryUnsupported: 'Táto krajina ešte nie je podporovaná.',
                noVehicle: 'Nenašli sa žiadne údaje o vozidle.',
                unknown: 'Neznáme',
                usingCache: 'Zobrazujú sa výsledky z vyrovnávacej pamäte z dôvodu chyby API.',
                resultsFor: 'Výsledky pre',
                foundVehicle: 'Vozidlo nájdené'
              }

: IS_BG
  ? {
      labelMake: 'Марка',
      labelModel: 'Модел',
      loading: 'Зареждане на продукти…',
      enterPlate: 'Въведете регистрационен номер.',
      lookupError: 'Грешка при търсене на регистрационния номер.',
      countryUnsupported: 'Тази държава все още не се поддържа.',
      noVehicle: 'Не са намерени данни за автомобила.',
      unknown: 'Неизвестно',
      usingCache: 'Показват се кеширани резултати поради API грешка.',
      resultsFor: 'Резултати за',
      foundVehicle: 'Намерено превозно средство'
    }

    : IS_GR
  ? {
      labelMake: 'Μάρκα',
      labelModel: 'Μοντέλο',
      loading: 'Φόρτωση προϊόντων…',
      enterPlate: 'Εισαγάγετε αριθμό κυκλοφορίας.',
      lookupError: 'Σφάλμα κατά την αναζήτηση της πινακίδας.',
      countryUnsupported: 'Αυτή η χώρα δεν υποστηρίζεται ακόμη.',
      noVehicle: 'Δεν βρέθηκαν στοιχεία οχήματος.',
      unknown: 'Άγνωστο',
      usingCache: 'Εμφάνιση αποθηκευμένων αποτελεσμάτων λόγω σφάλματος API.',
      resultsFor: 'Αποτελέσματα για',
      foundVehicle: 'Βρέθηκε όχημα'
    }

: IS_ES
  ? {
      labelMake: 'Marca',
      labelModel: 'Modelo',
      loading: 'Cargando productos…',
      enterPlate: 'Introduce una matrícula.',
      lookupError: 'Error al buscar la matrícula.',
      countryUnsupported: 'Este país aún no está disponible.',
      noVehicle: 'No se encontraron datos del vehículo.',
      unknown: 'Desconocido',
      usingCache: 'Mostrando resultados en caché debido a un error de API.',
      resultsFor: 'Resultados para',
      foundVehicle: 'Vehículo encontrado'
    }
: IS_PT
  ? {
      labelMake: 'Marca',
      labelModel: 'Modelo',
      loading: 'A carregar produtos…',
      enterPlate: 'Introduza uma matrícula.',
      lookupError: 'Erro ao pesquisar a matrícula.',
      countryUnsupported: 'Este país ainda não é suportado.',
      noVehicle: 'Não foram encontrados dados do veículo.',
      unknown: 'Desconhecido',
      usingCache: 'A mostrar resultados em cache devido a erro da API.',
      resultsFor: 'Resultados para',
      foundVehicle: 'Veículo encontrado'
    }
: IS_IT
  ? {
      labelMake: 'Marca',
      labelModel: 'Modello',
      loading: 'Caricamento prodotti…',
      enterPlate: 'Inserisci una targa.',
      lookupError: 'Errore durante la ricerca della targa.',
      countryUnsupported: 'Questo paese non è ancora supportato.',
      noVehicle: 'Nessun dato del veicolo trovato.',
      unknown: 'Sconosciuto',
      usingCache: 'Visualizzazione dei risultati in cache a causa di un errore API.',
      resultsFor: 'Risultati per',
      foundVehicle: 'Veicolo trovato'
    }
: IS_FI
  ? {
      labelMake: 'Merkki',
      labelModel: 'Malli',
      loading: 'Haetaan sopivia tuotteita…',
      enterPlate: 'Syötä rekisteritunnus.',
      lookupError: 'Virhe rekisteritunnuksen haussa.',
      countryUnsupported: 'Tätä maata ei vielä tueta.',
      noVehicle: 'Ajoneuvotietoja ei löytynyt.',
      unknown: 'Tuntematon',
      usingCache: 'Näytetään välimuistissa olevat tulokset API-virheen vuoksi.',
      resultsFor: 'Tulokset haulle',
      foundVehicle: 'Löydetty ajoneuvo'
    }
: IS_HU
  ? {
      labelMake: 'Márka',
      labelModel: 'Modell',
      loading: 'Termékek betöltése…',
      enterPlate: 'Adja meg a rendszámot.',
      lookupError: 'Hiba történt a rendszám keresésekor.',
      countryUnsupported: 'Ez az ország még nem támogatott.',
      noVehicle: 'Nem találhatók járműadatok.',
      unknown: 'Ismeretlen',
      usingCache: 'Gyorsítótárazott eredmények megjelenítése API-hiba miatt.',
      resultsFor: 'Találatok erre',
      foundVehicle: 'Jármű megtalálva'
    }

: IS_AT
  ? {
      labelMake: 'Marke',
      labelModel: 'Modell',
      loading: 'Produkte werden geladen…',
      enterPlate: 'Kennzeichen eingeben.',
      lookupError: 'Fehler bei der Kennzeichenabfrage.',
      countryUnsupported: 'Dieses Land wird noch nicht unterstützt.',
      noVehicle: 'Keine Fahrzeugdaten gefunden.',
      unknown: 'Unbekannt',
      usingCache: 'Zwischengespeicherte Ergebnisse wegen API-Fehler angezeigt.',
      resultsFor: 'Ergebnisse für',
      foundVehicle: 'Fahrzeug gefunden'
    }


            : IS_EN
              ? {
                  labelMake: 'Make',
                  labelModel: 'Model',
                  loading: 'Fetching products…',
                  enterPlate: 'Enter a license plate.',
                  lookupError: 'Error looking up license plate.',
                  countryUnsupported: 'Country not supported yet.',
                  noVehicle: 'No vehicle data found.',
                  unknown: 'Unknown',
                  usingCache: 'Showing cached results due to API error.',
                  resultsFor: 'Results for',
                  foundVehicle: 'Vehicle found'
                }
              : {
                  labelMake: 'Mærke',
                  labelModel: 'Model',
                  loading: 'Henter produkter…',
                  enterPlate: 'Indtast en nummerplade.',
                  lookupError: 'Fejl ved opslag af nummerplade.',
                  countryUnsupported: 'Landet er ikke understøttet endnu.',
                  noVehicle: 'Ingen køretøjsdata fundet.',
                  unknown: 'Ukendt',
                  usingCache: 'Viser cachede resultater pga. API-fejl.',
                  resultsFor: 'Resultater for',
                  foundVehicle: 'Bil fundet'
                };


                const RESULT_CARD_TEXT = IS_SE
  ? {
      fitsCar: 'Till bil',
      button: 'Gå till varan'
    }


      : IS_NO
    ? {
        fitsCar: 'Til bil',
        button: 'Gå til varen'
      }



  : IS_NL
    ? {
        fitsCar: 'Voor auto',
        button: 'Ga naar product'
      }
    : IS_PL
      ? {
          fitsCar: 'Do auta',
          button: 'Przejdź do produktu'
        }
      : IS_FR
        ? {
            fitsCar: 'Pour voiture',
            button: 'Voir le produit'
          }
        : IS_SI
          ? {
              fitsCar: 'Za vozilo',
              button: 'Pojdi na izdelek'
            }
          : IS_SK
            ? {
                fitsCar: 'Pre vozidlo',
                button: 'Prejsť na produkt'
              }

              : IS_BG
  ? { fitsCar: 'За автомобил', button: 'Към продукта' }
  : IS_GR
  ? { fitsCar: 'Για αυτοκίνητο', button: 'Δείτε το προϊόν' }
: IS_ES
  ? { fitsCar: 'Para coche', button: 'Ver producto' }
: IS_PT
  ? { fitsCar: 'Para o carro', button: 'Ver produto' }
: IS_IT
  ? { fitsCar: 'Per auto', button: 'Vai al prodotto' }
: IS_FI
  ? { fitsCar: 'Autolle', button: 'Siirry tuotteeseen' }
: IS_HU
  ? { fitsCar: 'Autóhoz', button: 'Tovább a termékhez' }
: IS_AT
  ? { fitsCar: 'Für Auto', button: 'Zum Produkt' }


            : IS_EN
              ? {
                  fitsCar: 'For car',
                  button: 'Go to product'
                }
              : {
                  fitsCar: 'Til bil',
                  button: 'Gå til varen'
                };

let CURRENT_LOOKUP_PLATE = '';

const PRODUCTS_API_URL =
  'https://bilmedie-products-api.casper-3d6.workers.dev/';
const __FACET_CACHE__ = { makes: null, modelsByMake: new Map() };

function now() { return Date.now(); }

function handleize(str) {
  return (str || '')
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

function normalizeYearValue(value) {
  const year = Number.parseInt(String(value || '').trim(), 10);
  return Number.isFinite(year) && year > 1900 && year < 2100 ? year : null;
}

function formatYearRange(yearFrom, yearTo) {
  const fromYear = normalizeYearValue(yearFrom);
  const toYear = normalizeYearValue(yearTo);
  if (fromYear && toYear) return `${fromYear}–${toYear}`;
  if (fromYear) return `${fromYear}+`;
  if (toYear) return `–${toYear}`;
  return '';
}


function getVehicleCandidateYears(vehicleMeta = {}) {
  const year =
    normalizeYearValue(vehicleMeta.year) ||
    normalizeYearValue(vehicleMeta.yearFrom) ||
    normalizeYearValue(vehicleMeta.yearTo);

  if (!year) return [];

  const years = [year];

  const rawDate =
    vehicleMeta.first_registration ||
    vehicleMeta.firstRegistration ||
    vehicleMeta.registration_date ||
    vehicleMeta.registrationDate ||
    '';

  const dateText = String(rawDate || '').trim();
  const isoMatch = dateText.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})/);
  const dkMatch = dateText.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})/);

  let month = null;

  if (isoMatch) {
    month = Number.parseInt(isoMatch[2], 10);
  } else if (dkMatch) {
    month = Number.parseInt(dkMatch[2], 10);
  }

  // Sen registrering kan være næste modelår.
  // Fx 11/2019 kan godt passe på en 2020-model.
  if (month && month >= 9) {
    years.push(year + 1);
  }

  return [...new Set(years)];
}

function productMatchesVehicleYears(product, vehicleMeta = {}) {
  const candidateYears = getVehicleCandidateYears(vehicleMeta);

  if (!candidateYears.length) return true;

  const fromYear = normalizeYearValue(product.year_from);
  const toYear = normalizeYearValue(product.year_to);

  if (!fromYear && !toYear) return true;

  return candidateYears.some((year) => {
    if (fromYear && toYear) return year >= fromYear && year <= toYear;
    if (fromYear) return year >= fromYear;
    if (toYear) return year <= toYear;
    return true;
  });
}



function splitMetaValue(value) {
  return String(value || '')
    .split(/[,|;]/)
    .map((part) => part.trim())
    .filter(Boolean);
}

function normalizeComparableText(value) {
  return handleize(value).replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
}

function normalizeBrand(value) {
  const text = normalizeComparableText(value);

  if (text === 'vw') return 'volkswagen';
  if (text === 'volks wagen') return 'volkswagen';

  if (text === 'mercedes') return 'mercedes';
  if (text === 'mercedes benz') return 'mercedes-benz';
  if (text === 'mercedes-benz') return 'mercedes-benz';

  return text;
}

function ensureLoaderStyles() {
  if (document.getElementById('bm-loader-style')) return;

  const s = document.createElement('style');
  s.id = 'bm-loader-style';

  s.textContent = `
    .bm-loading {
      display: inline-flex;
      align-items: center;
      gap: .5rem;
      opacity: .9;
    }

    .bm-loading__spinner {
      width: 1em;
      height: 1em;
      border: .2em solid currentColor;
      border-right-color: transparent;
      border-radius: 50%;
      animation: bmspin .8s linear infinite;
    }

    @keyframes bmspin {
      to {
        transform: rotate(360deg);
      }
    }


.vehicle-results-grid {
  align-items: stretch !important;
}

.vehicle-results-grid > .vehicle-card {
  display: flex !important;
  align-self: stretch !important;
  height: auto !important;
}

.vehicle-card__link {
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
  height: 100% !important;
  color: inherit;
  text-decoration: none;
}



.vehicle-card__link > img.vehicle-card__image {
  display: block !important;
  width: 100% !important;
  height: 190px !important;
  min-height: 0 !important;
  max-height: 190px !important;
  aspect-ratio: auto !important;
  object-fit: contain !important;
  margin: 0 !important;
}



    .vehicle-card__content {
      display: flex;
      flex-direction: column;
      flex: 1;
     padding: 12px 16px 16px;
    }

    .vehicle-card__title {
     margin: 0 0 4px;
      font-size: 15px;
      line-height: 1.25;
      font-weight: 700;
    }

    .vehicle-card__price {
      margin: 0 0 18px;
      font-size: 21px;
      line-height: 1.2;
      font-weight: 800;
    }




    .vehicle-card__plate {
  display: inline-flex;
  align-items: stretch;
  align-self: center;
  box-sizing: border-box;
  overflow: hidden;

  width: 218px;
  height: 48px;
  margin: 0 auto 0px;

  background: #f7f7f4;
  color: #080808;

  border: 2px solid #d4202f;
  border-radius: 5px;

  box-shadow:
    inset 0 0 0 2px #f7f7f4,
    0 1px 3px rgba(0, 0, 0, .18);

  font-family: Arial, Helvetica, sans-serif;
}

.vehicle-card__plate-country {
  display: flex;
  flex: 0 0 36px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  padding-top: 3px;

  background: #003399;
}

.vehicle-card__plate-flag {
  width: 22px;
  height: 22px;
  margin: 0;
}

.vehicle-card__plate-flag img {
  display: block;
  width: 24px;
  height: 17px;
  margin: 0;
  object-fit: contain;
}

.vehicle-card__plate-country-code {
  margin-top: auto;
  margin-bottom: 3px;

  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.vehicle-card__plate-number {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-width: 0;
  padding: 0 9px;

  color: #080808;
  text-align: center;

  font-family: Arial, Helvetica, sans-serif;
  font-size: 25px;
  line-height: 1;
  font-weight: 800;
  letter-spacing: 2px;
  white-space: nowrap;
}
 

 


 
 .vehicle-card__button {
  display: block;
  margin-top: auto !important;
}
  `;

  document.head.appendChild(s);
}

async function apiJson(url) {
  const res = await fetch(url, { credentials: 'same-origin' });
  if (!res.ok) throw new Error('api-http-' + res.status);
  const json = await res.json();
  if (!json?.success) throw new Error(json?.error || 'api-error');
  return json;
}


async function fetchModelsForMake(make) {
  const key = normalizeBrand(make);
  if (!key) return [];
  if (__FACET_CACHE__.modelsByMake.has(key)) {
    return __FACET_CACHE__.modelsByMake.get(key) || [];
  }
  const qp = new URLSearchParams({ facet: 'models', make: key });
  const json = await apiJson(`${PRODUCTS_API_URL}?${qp.toString()}`);
  const models = Array.isArray(json?.data) ? json.data : [];
  __FACET_CACHE__.modelsByMake.set(key, models);
  return models;
}

function getMakeLookupVariants(make) {
  const raw = String(make || '').trim();
  const normalized = normalizeBrand(raw);

  const variants = new Set();

  if (raw) variants.add(raw);

  if (normalized === 'mercedes-benz' || normalized === 'mercedes benz') {
    variants.add('Mercedes-Benz');
    variants.add('Mercedes Benz');
    variants.add('MERCEDES-BENZ');
    variants.add('MERCEDES BENZ');
  }

  if (normalized === 'volkswagen') {
    variants.add('Volkswagen');
    variants.add('VW');
  }

  return Array.from(variants).filter(Boolean);
}

function getModelLookupVariants(model) {
  const raw = String(model || '').trim();

  const variants = new Set();

  if (raw) variants.add(raw);

  if (raw.includes('-')) {
    variants.add(raw.replace(/-/g, ' '));
  }

  if (/\b[A-Z]\s+Klasse\b/i.test(raw)) {
    variants.add(raw.replace(/\b([A-Z])\s+Klasse\b/gi, '$1-Klasse'));
  }

  return Array.from(variants).filter(Boolean);
}

function modelMatchesProduct(productModel, lookupModel) {
  const lookup = normalizeComparableText(lookupModel);

  if (!lookup) return true;

  const productParts = String(productModel || '')
    .split(/[/,|;]/)
    .map((part) => normalizeComparableText(part))
    .filter(Boolean);

  if (!productParts.length) return true;

  // Almindelig VW Golf må IKKE matche Golf Sportsvan
  if (lookup === 'golf') {
    return productParts.some((part) => {
      if (part.includes('sportsvan')) return false;
      if (part.includes('plus')) return false;
      if (part.includes('sv')) return false;

      return (
        part === 'golf' ||
        part === 'golf 7' ||
        part === 'golf vii' ||
        part === 'golf mk7' ||
        part === 'golf gte'
      );
    });
  }

  // Golf Sportsvan skal kun matche Golf Sportsvan
  if (lookup === 'golf sportsvan') {
    return productParts.some((part) => part === 'golf sportsvan');
  }

  return productParts.some((part) => {
    return part === lookup || part.includes(lookup) || lookup.includes(part);
  });
}

function makeMatchesProduct(productMake, lookupMake) {
  const lookup = normalizeBrand(lookupMake);

  if (!lookup) return true;

  const productMakes = String(productMake || '')
    .split(/[/,|;]/)
    .map((part) => normalizeBrand(part))
    .filter(Boolean);

  if (!productMakes.length) return true;

  const mercedesValues = new Set([
    'mercedes',
    'mercedes-benz'
  ]);

  const volkswagenValues = new Set([
    'vw',
    'volkswagen'
  ]);

  return productMakes.some((product) => {
    if (product === lookup) return true;

    if (mercedesValues.has(product) && mercedesValues.has(lookup)) {
      return true;
    }

    if (volkswagenValues.has(product) && volkswagenValues.has(lookup)) {
      return true;
    }

    return false;
  });
}


async function fetchProductsByVehicle({ make, model, year }) {
  const cleanMake = String(make || '').trim();
  const rawModel = String(model || '').trim();

const cleanModel =
  /\bfocus\b/i.test(rawModel)
    ? 'Focus'
    : rawModel;
  const yearValue = normalizeYearValue(year);

  const qp = new URLSearchParams();

  if (cleanMake) {
    qp.set('make', cleanMake);
  }

if (cleanModel) {
  qp.set('model', cleanModel);
}

  if (yearValue) {
    qp.set('year', String(yearValue));
  }

  try {
    const json = await apiJson(
      `${PRODUCTS_API_URL}?${qp.toString()}`
    );

    const items = Array.isArray(json?.data)
      ? json.data
      : [];






    return items
      .filter((product) => {
        return (
          makeMatchesProduct(product.make, cleanMake) &&
          modelMatchesProduct(product.model, cleanModel) &&
          productMatchesVehicleYears(product, {
            year: yearValue
          })
        );
      })
      .sort((a, b) => {
        const lookup =
          normalizeComparableText(cleanModel);

        const aModel =
          normalizeComparableText(a.model || '');

        const bModel =
          normalizeComparableText(b.model || '');

        const aExact = aModel === lookup;
        const bExact = bModel === lookup;

        if (aExact && !bExact) return -1;
        if (!aExact && bExact) return 1;

        const aCombo =
          String(a.model || '').match(/[/,|;]/);

        const bCombo =
          String(b.model || '').match(/[/,|;]/);

        if (!aCombo && bCombo) return -1;
        if (aCombo && !bCombo) return 1;

        return 0;
      });
  } catch (error) {
    console.error('Product lookup failed:', error);
    return [];
  }
}


function getVehicleCardLocale() {
  if (IS_SE) return 'sv-SE';
  if (IS_NO) return 'nb-NO';
  if (IS_NL) return 'nl-NL';
  if (IS_PL) return 'pl-PL';
  if (IS_FR) return 'fr-FR';
  if (IS_SI) return 'sl-SI';
  if (IS_SK) return 'sk-SK';
  if (IS_BG) return 'bg-BG';
  if (IS_GR) return 'el-GR';
  if (IS_ES) return 'es-ES';
  if (IS_PT) return 'pt-PT';
  if (IS_IT) return 'it-IT';
  if (IS_FI) return 'fi-FI';
  if (IS_HU) return 'hu-HU';
  if (IS_AT) return 'de-AT';
  if (IS_EN) return 'en-GB';

  return 'da-DK';
}

function getVehicleCardCurrency() {
  if (IS_SE) return 'SEK';
  if (IS_NO) return 'NOK';
  if (IS_PL) return 'PLN';
  if (IS_BG) return 'BGN';
  if (IS_HU) return 'HUF';

  // Danmark
  if (
    !IS_SE &&
    !IS_NO &&
    !IS_NL &&
    !IS_PL &&
    !IS_FR &&
    !IS_SI &&
    !IS_SK &&
    !IS_EN &&
    !IS_BG &&
    !IS_GR &&
    !IS_ES &&
    !IS_PT &&
    !IS_IT &&
    !IS_FI &&
    !IS_HU &&
    !IS_AT
  ) {
    return 'DKK';
  }

  return 'EUR';
}

function formatVehicleProductPrice(item) {
  const rawPrice =
    item.price ??
    item.price_amount ??
    item.min_price ??
    '';

  if (rawPrice === '') {
    return '';
  }

  const numericPrice = Number(
    String(rawPrice)
      .trim()
      .replace(/\s/g, '')
      .replace(',', '.')
      .replace(/[^0-9.-]/g, '')
  );

  if (!Number.isFinite(numericPrice)) {
    return '';
  }

  const currency =
    item.currency ||
    item.currency_code ||
    getVehicleCardCurrency();

  return new Intl.NumberFormat(getVehicleCardLocale(), {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(Math.round(numericPrice));
}

function getVehiclePlateCountry() {
  if (IS_SE) return 'S';
  if (IS_NO) return 'N';
  if (IS_NL) return 'NL';
  if (IS_PL) return 'PL';
  if (IS_FR) return 'F';
  if (IS_SI) return 'SLO';
  if (IS_SK) return 'SK';
  if (IS_BG) return 'BG';
  if (IS_GR) return 'GR';
  if (IS_ES) return 'E';
  if (IS_PT) return 'P';
  if (IS_IT) return 'I';
  if (IS_FI) return 'FIN';
  if (IS_HU) return 'H';
  if (IS_AT) return 'A';
  if (IS_EN) return 'GB';

  return 'DK';
}

function getVehiclePlateClass() {
  if (IS_NL) return 'vehicle-card__plate--nl';
  if (IS_EN) return 'vehicle-card__plate--gb';

  return 'vehicle-card__plate--white';
}

function renderVehicleProducts(items) {
  if (!items.length) return `<p>${I18N.noVehicle}</p>`;

  const plateLabel = CURRENT_LOOKUP_PLATE || '';

  const cards = items.map((item) => {
    const title = item.title || '';

    const price = formatVehicleProductPrice(item);

const showPrice =
  window.location.hostname === 'bilmedie.dk' ||
  window.location.hostname === 'www.bilmedie.dk';

    const imageMarkup = item.image
      ? `
       <img
  class="vehicle-card__image"
  src="${item.image}"
  alt="${title.replace(/"/g, '&quot;')}"
  loading="lazy"
  width="600"
  height="400"
>
      `
      : '';

    const url =
      item.url ||
      (item.handle ? `/products/${item.handle}` : '#');

    const plateCountry = getVehiclePlateCountry();
const plateClass = getVehiclePlateClass();

const fitmentMarkup = plateLabel
  ? `
    <div
      class="vehicle-card__plate ${plateClass}"
      aria-label="${RESULT_CARD_TEXT.fitsCar}: ${plateLabel}"
    >
      <span class="vehicle-card__plate-country">
        <span class="vehicle-card__plate-flag">
          <img
            src="https://cdn.shopify.com/s/files/1/0682/7465/1301/files/eu-flag.png?v=1736944283"
            alt="EU"
            width="24"
            height="17"
          >
        </span>

        <span class="vehicle-card__plate-country-code">
          ${plateCountry}
        </span>
      </span>

      <span class="vehicle-card__plate-number">
        ${plateLabel}
      </span>
    </div>
  `
  : '';

    const titleMarkup = title
      ? `
        <h3 class="vehicle-card__title">
          ${title}
        </h3>
      `
      : '';

   const priceMarkup =
  showPrice && price
    ? `
      <p class="vehicle-card__price">
        ${price}
      </p>
    `
    : '';

    return `
      <li class="vehicle-card">
        <a href="${url}" class="vehicle-card__link">
          ${imageMarkup}

          

          <div class="vehicle-card__content">
            ${fitmentMarkup}
            ${titleMarkup}
            ${priceMarkup}

            <span class="vehicle-card__button">
              ${RESULT_CARD_TEXT.button}
            </span>
          </div>
        </a>
      </li>
    `;
  }).join('');

  return `
    <ul
      id="main-collection-product-grid"
      class="productGrid vehicle-results-grid"
    >
      ${cards}
    </ul>
  `;
}

function formatLookupHeading(make, model, product) {
  const makeLabel = (product?.make || make || I18N.unknown).toString().trim();
  const modelLabel = (product?.model || model || I18N.unknown).toString().trim();
  const yearRange = product ? formatYearRange(product.year_from, product.year_to) : '';
  return yearRange ? `${makeLabel} ${modelLabel} ${yearRange}` : `${makeLabel} ${modelLabel}`;
}





function formatVehicleDate(data = {}) {
  // Kun carmedia24.pl:
  // Brug produktionsår/modelår og aldrig første registreringsdato.
 if (IS_PL) {
  const rawYear =
    data.ManufacturingYear ||
    data.manufacturingYear ||
    data.manufacturing_year ||
    data.productionYear ||
    data.production_year ||
    data.manufactureYear ||
    data.manufacture_year ||
    data.year_of_manufacture ||
    data.rokProdukcji ||
    data.rok_modelowy ||
    '';

  if (!rawYear) return '';

  const yearMatch = String(rawYear).match(/(19|20)\d{2}/);
  return yearMatch ? yearMatch[0] : '';
}

  
  
  const raw =
    data.first_registration ||
    data.firstRegistration ||
    data.registration_date ||
    data.registrationDate ||
    data.date_first_registration ||
    data.firstRegistrationDate ||
    data.first_registration_date ||
    data.FirstRegistrationDate ||
    data.registrationFirstDate ||
    data.firstRegDate ||
    data.first_reg_date ||

    // Sverige/Polen mulige felter
    data.Fordonsar ||
    data.fordonsar ||
    data.fordonsår ||
    data.Arsmodell ||
    data.arsmodell ||
    data.årsmodell ||
    data.modelYear ||
    data.model_year ||
    data.year ||
    data.Year ||
    data.productionYear ||
    data.production_year ||
    data.manufactureYear ||
    data.manufacture_year ||
    data.year_of_manufacture ||
    data.registrationYear ||
    data.registration_year ||
    data.regYear ||
    data.reg_year ||
    data.pierwszaRejestracja ||
    data.dataPierwszejRejestracji ||
    data.rokProdukcji ||
    data.rok_modelowy ||
    '';

  if (!raw) return '';

  const str = String(raw).trim();

  // 2019-11-01, 2019/11/01, 2019.11.01
  const isoMatch = str.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})/);
  if (isoMatch) {
    const year = isoMatch[1];
    const month = isoMatch[2].padStart(2, '0');
    return `${month}/${year}`;
  }

  // 01-11-2019, 01/11/2019, 01.11.2019
  const dkMatch = str.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})/);
  if (dkMatch) {
    const month = dkMatch[2].padStart(2, '0');
    const year = dkMatch[3];
    return `${month}/${year}`;
  }

  // Hvis API'et kun sender årstal, fx 2014
  const yearOnly = str.match(/(19|20)\d{2}/);
  if (yearOnly) {
    return yearOnly[0];
  }

  return '';
}

function formatFoundVehicleHeading(make, model, data = {}) {
  const makeLabel = (make || I18N.unknown).toString().trim();
  const modelLabel = (model || I18N.unknown).toString().trim();
  const dateLabel = formatVehicleDate(data);

  return dateLabel
    ? `${makeLabel} ${modelLabel} - ${dateLabel}`
    : `${makeLabel} ${modelLabel}`;
}

function readVehicleYear(data) {
  // Kun carmedia24.pl:
  // Brug produktionsår/modelår og aldrig første registreringsdato.
 if (IS_PL) {
  return normalizeYearValue(
    data?.ManufacturingYear ||
    data?.manufacturingYear ||
    data?.manufacturing_year ||
    data?.productionYear ||
    data?.production_year ||
    data?.manufactureYear ||
    data?.manufacture_year ||
    data?.year_of_manufacture ||
    data?.rokProdukcji ||
    data?.rok_modelowy
  );
}

  let yr = normalizeYearValue(
    data?.year ||
    data?.Year ||
    data?.modelYear ||
    data?.model_year ||
    data?.productionYear ||
    data?.production_year ||
    data?.manufactureYear ||
    data?.manufacture_year ||
    data?.year_of_manufacture ||
    data?.registrationYear ||
    data?.registration_year ||
    data?.regYear ||
    data?.reg_year ||
    data?.firstRegistrationDate ||
    data?.first_registration_date ||
    data?.FirstRegistrationDate ||
    data?.registrationFirstDate ||
    data?.firstRegDate ||
    data?.first_reg_date ||
    data?.Fordonsar ||
    data?.fordonsar ||
    data?.fordonsår ||
    data?.Arsmodell ||
    data?.arsmodell ||
    data?.årsmodell ||
    data?.pierwszaRejestracja ||
    data?.dataPierwszejRejestracji ||
    data?.rokProdukcji ||
    data?.rok_modelowy
  );

  const rawDate =
    data?.first_registration ||
    data?.firstRegistration ||
    data?.registration_date ||
    data?.registrationDate ||
    data?.date_first_registration ||
    data?.firstRegistrationDate ||
    data?.first_registration_date ||
    data?.FirstRegistrationDate ||
    data?.registrationFirstDate ||
    data?.firstRegDate ||
    data?.first_reg_date ||
    data?.pierwszaRejestracja ||
    data?.dataPierwszejRejestracji ||
    '';

  if (!yr && rawDate) {
    const match = String(rawDate).match(/(19|20)\d{2}/);
    if (match) yr = normalizeYearValue(match[0]);
  }

  return yr;
}

function cleanVehicleModelForProductLookup(model, make = '') {
  let value = String(model || '').trim();

  const makeText = String(make || '').trim();

  if (makeText) {
    const escapedMake = makeText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    value = value.replace(new RegExp(`^${escapedMake}\\s+`, 'i'), '').trim();
  }

  value = value
    .replace(/`/g, "'")
    .replace(/\bvan\b/gi, '')
    .replace(/\bvarebil\b/gi, '')
    .replace(/\bpanel van\b/gi, '')
    .replace(/\bstationcar\b/gi, '')
    .replace(/\bestate\b/gi, '')
    .replace(/\bsw\b/gi, '')
    .replace(/\bhatchback\b/gi, '')
    .replace(/\bsedan\b/gi, '')
    .replace(/\bcoupe\b/gi, '')
    .replace(/\bcabriolet\b/gi, '')
    .replace(/\s+/g, ' ')
    .trim();

    const normalized = value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[`´']/g, '')
    .replace(/\s+/g, ' ')
    .trim();

   const makeNormalized = normalizeBrand(make);

   // Saab:
// "9-3 Kombi (E50)" -> "9-3"
// "9-5 Sedan" -> "9-5"
if (makeNormalized === 'saab') {
  const saabMatch = value.match(/\b(9[-\s]?(?:3|5))\b/i);

  if (saabMatch) {
    return saabMatch[1].replace(/\s/g, '-');
  }
}


  // Nissan:
  // "Qashqai II" -> "Qashqai"
  // "Qashqai 2" -> "Qashqai"
  // "Qashqai+2" -> "Qashqai"
  if (makeNormalized === 'nissan') {
    const nissanModel = normalized
      .replace(/^nissan\s+/i, '')
      .replace(/\s+/g, ' ')
      .trim();

    if (
      nissanModel === 'qashqai' ||
      nissanModel === 'qashqai ii' ||
      nissanModel === 'qashqai 2' ||
      nissanModel === 'qashqai+2' ||
      nissanModel === 'qashqai +2'
    ) {
      return 'Qashqai';
    }

    const qashqaiMatch = value.match(/\bQashqai\b/i);
    if (qashqaiMatch) {
      return 'Qashqai';
    }
  }

  const modelAliases = {
    // Mercedes korte modelnavne
    'a': 'A-Klasse',
    'b': 'B-Klasse',
    'c': 'C-Klasse',
    'e': 'E-Klasse',
    'g': 'G-Klasse',
    'r': 'R-Klasse',
    's': 'S-Klasse',
    'v': 'V-Klasse',

    // BMW
    '1er': '1 serie',
    '1 er': '1 serie',
    '1er serie': '1 serie',
    '1 series': '1 serie',
    '1 serie': '1 serie',

    '2er': '2 serie',
    '2 er': '2 serie',
    '2 series': '2 serie',
    '2 serie': '2 serie',

    '3er': '3 serie',
    '3 er': '3 serie',
    '3 series': '3 serie',
    '3 serie': '3 serie',

    '4er': '4 serie',
    '4 er': '4 serie',
    '4 series': '4 serie',
    '4 serie': '4 serie',

    '5er': '5 serie',
    '5 er': '5 serie',
    '5 series': '5 serie',
    '5 serie': '5 serie',

    '6er': '6 serie',
    '6 er': '6 serie',
    '6 series': '6 serie',
    '6 serie': '6 serie',

    '7er': '7 serie',
    '7 er': '7 serie',
    '7 series': '7 serie',
    '7 serie': '7 serie',

    // Peugeot/Toyota/Citroën
    '107': '107',
    '107 van': '107',
    '107 hatchback': '107'
  };

  if (modelAliases[normalized]) {
    return modelAliases[normalized];
  }

// Audi:
// "A4 1.8 TFSI Kat. MR`07 E4 B8" -> "A4"
// "A 4 CABRIOLET" -> "A4"
// "Q 5" -> "Q5"
const audiSpacedMatch = value.match(/\b(A|Q)\s*([1-8])\b/i);
if (audiSpacedMatch) {
  return `${audiSpacedMatch[1].toUpperCase()}${audiSpacedMatch[2]}`;
}

const audiMatch = value.match(/\b(A1|A2|A3|A4|A5|A6|A7|A8|Q2|Q3|Q4|Q5|Q7|Q8|TT|R8)\b/i);
if (audiMatch) {
  return audiMatch[1].toUpperCase();
}

  // VW:
// "GOLF GTE Hybrid" -> "Golf"
// "Golf 1.6 TDI ..." -> "Golf"
// "Golf Sportsvan" skal blive "Golf Sportsvan" og ikke almindelig Golf
const vwSportsvanMatch = value.match(/\bGolf\s+Sportsvan\b/i);
if (vwSportsvanMatch) {
  return 'Golf Sportsvan';
}

const vwMatch = value.match(/\b(Golf|Passat|Polo|Touran|Tiguan|Touareg|Caddy|Transporter|Sharan|T-Roc|T-Cross)\b/i);
if (vwMatch) {
  return vwMatch[1];
}

  // Volvo:
  // "V 70" -> "V70"
  // "VOLVO V 70" -> "V70"
  // "V-klasse" / "V Klasse" bruges af nogle API'er og skal matche V70
  if (makeNormalized === 'volvo') {
    const volvoAlias = normalized
      .replace(/^volvo\s+/i, '')
      .replace(/\s+/g, ' ')
      .trim();

    const volvoAliases = {
      'v 70': 'V70',
      'v-70': 'V70',
      'v70': 'V70',
      'v klasse': 'V70',
      'v-klasse': 'V70',

      'v 40': 'V40',
      'v40': 'V40',
      'v 50': 'V50',
      'v50': 'V50',
      'v 60': 'V60',
      'v60': 'V60',
      'v 90': 'V90',
      'v90': 'V90',

      's 40': 'S40',
      's40': 'S40',
      's 60': 'S60',
      's60': 'S60',
      's 80': 'S80',
      's80': 'S80',
      's 90': 'S90',
      's90': 'S90',

      'xc 40': 'XC40',
      'xc40': 'XC40',
      'xc 60': 'XC60',
      'xc60': 'XC60',
      'xc 70': 'XC70',
      'xc70': 'XC70',
      'xc 90': 'XC90',
      'xc90': 'XC90',

      'c 30': 'C30',
      'c30': 'C30'
    };

    if (volvoAliases[volvoAlias]) {
      return volvoAliases[volvoAlias];
    }

    const volvoSpacedMatch = volvoAlias.match(/\b(V|S|C|XC)\s*-?\s*(\d{2})\b/i);
    if (volvoSpacedMatch) {
      return `${volvoSpacedMatch[1].toUpperCase()}${volvoSpacedMatch[2]}`;
    }
  }

  // Fiat:
// "500" / "FIAT 500" skal blive som 500, ikke BMW 5 serie
if (/^500\b/i.test(value)) {
  return '500';
}

// BMW:
// "320d ..." -> "3 serie"
// "3 Cabriolet (E46)" -> "3 serie"
// "5 Touring (E61)" -> "5 serie"
// Reglen må kun bruges, når mærket er BMW.

if (makeNormalized === 'bmw') {
  // Modeller som "3 (E46)", "3 Serie", "5 (E61)" osv.
  const bmwSeriesMatch = value.match(
    /^\s*([1-7])(?:\s*[- ]?\s*serie)?(?:\s|\(|$)/i
  );

  if (bmwSeriesMatch) {
    return `${bmwSeriesMatch[1]} serie`;
  }

  // Modeller som "320d", "520i", "118i" osv.
  const bmwModelNumberMatch = value.match(
    /\b([1-7])\d{2}[a-z]*\b/i
  );

  if (bmwModelNumberMatch) {
    return `${bmwModelNumberMatch[1]} serie`;
  }

  // BMW-chassiskoder som E46, E90, F30 osv.
  const bmwChassisMatch = value.match(
    /\b(E46|E90|E91|E92|E93)\b/i
  );

  if (bmwChassisMatch) {
    return '3 serie';
  }
}

  // Mercedes Sprinter:
  // "902.6KA" / "902.xxx" -> "Sprinter"
  // W901/W902 passer til Sprinter ca. 1995-2005
  if (makeNormalized === 'mercedes-benz' || makeNormalized === 'mercedes') {
    const mercedesModel = normalized
      .replace(/^mercedes[-\s]*benz\s+/i, '')
      .replace(/^mercedes\s+/i, '')
      .trim();

    if (
      /^901\b/i.test(mercedesModel) ||
      /^902\b/i.test(mercedesModel) ||
      /^w901\b/i.test(mercedesModel) ||
      /^w902\b/i.test(mercedesModel)
    ) {
      return 'Sprinter';
    }
  }


  // Mercedes SLK:
// "SLK (R170)" -> "SLK"
// "SLK 200 Kompressor" -> "SLK"
if (
  makeNormalized === 'mercedes' ||
  makeNormalized === 'mercedes-benz'
) {
  if (/\bSLK\b/i.test(value)) {
    return 'SLK';
  }
}



// Mercedes:
// "A 180 ..." -> "A-Klasse"
// Må kun bruges, når mærket faktisk er Mercedes.

if (
  makeNormalized === 'mercedes' ||
  makeNormalized === 'mercedes-benz'
) {
  const mercedesClassMatch = value.match(
    /\b([ABCEGSRV])\s?\d{2,3}\b/i
  );

  if (mercedesClassMatch) {
    return `${mercedesClassMatch[1].toUpperCase()}-Klasse`;
  }
}

  // Generel oprydning:
  // Fjerner motor-/emissionsdele efter modelnavnet
  value = value
    .replace(/\b\d+[.,]\d+\b.*$/i, '')
    .replace(/\b(TFSI|TDI|FSI|TSI|CDI|HDI|BlueHDI|DIESEL|BENZIN|KAT\.?|E[0-9]+|MR['’`]?\d+)\b.*$/gi, '')
    .replace(/\s+/g, ' ')
    .trim();

  return value;
}


async function showRelevantProducts(carMake, carModel, vehicleMeta = {}) {
  ensureLoaderStyles();




  const carInfoContainer = document.getElementById('car-info');
  const productResultsContainer = document.getElementById('product-results');

  const make = (carMake || '').toString().trim().replace(/,+$/, '');
  const model = (carModel || '').toString().trim();

  const year =
    normalizeYearValue(vehicleMeta.year) ||
    normalizeYearValue(vehicleMeta.yearFrom) ||
    normalizeYearValue(vehicleMeta.yearTo);

if (productResultsContainer) {
  const loadingText = vehicleMeta.country === 'PL'
    ? 'Sprawdzamy produkty pasujące do pojazdu…'
    : I18N.loading;

  productResultsContainer.innerHTML = `<div class="bm-loading" aria-busy="true"><span>${loadingText}</span><span class="bm-loading__spinner" aria-hidden="true"></span></div>`;
}



  try {
    let matches = await fetchProductsByVehicle({ make, model, year });

    matches = Array.isArray(matches) ? matches.slice() : [];

    // Ekstra sikkerhedsfilter i frontend:
    // Viser kun produkter hvor bilens årgang passer med produktets år fra/til.
    if (year) {
      matches = matches.filter((product) => productMatchesVehicleYears(product, vehicleMeta));
    }

    matches.sort((a, b) => {
      const aCarplay =
        (a.title || '').toLowerCase().includes('carplay') ||
        (Array.isArray(a.tags) && a.tags.some(tag => String(tag).toLowerCase().includes('carplay')));

      const bCarplay =
        (b.title || '').toLowerCase().includes('carplay') ||
        (Array.isArray(b.tags) && b.tags.some(tag => String(tag).toLowerCase().includes('carplay')));

      if (aCarplay === bCarplay) return 0;
      return aCarplay ? -1 : 1;
    });

    const heading = formatLookupHeading(make, model, matches[0]);

    if (carInfoContainer && !vehicleMeta.preserveHeading) {
      carInfoContainer.innerHTML = `<h4>${heading}</h4>`;
    }

    if (productResultsContainer) {
  productResultsContainer.innerHTML = renderVehicleProducts(matches);

  requestAnimationFrame(() => {
    const scrollTarget = carInfoContainer || productResultsContainer;

    const y =
      scrollTarget.getBoundingClientRect().top +
      window.scrollY -
      180;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  });
}


    return matches;
  } catch (error) {
    const heading = formatLookupHeading(make, model);

    if (carInfoContainer && !vehicleMeta.preserveHeading) {
      carInfoContainer.innerHTML = `<h4>${heading}</h4>`;
    }

    if (productResultsContainer) {
  productResultsContainer.innerHTML = renderVehicleProducts([]);

  requestAnimationFrame(() => {
    const scrollTarget = carInfoContainer || productResultsContainer;

    const y =
      scrollTarget.getBoundingClientRect().top +
      window.scrollY -
      1020;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  });
}

return [];
  }
}


function resolveCountryCode(badgeEl) {
  const raw = (badgeEl?.dataset?.country || badgeEl?.textContent || '').trim().toUpperCase();

  if ([
 
  'DK',
  'SE',
  'NO',
  'NL',
  'PL',
  'FR',
  'SI',
  'SK',
  'BG',
'GR',
'ES',
  'PT',
  'IT',
  'FI',
  'HU',
  'AT'
].includes(raw)) {
    return raw;
  }

  const host = (location.hostname || '').toLowerCase();

  if (host.endsWith('.se')) return 'SE';
  if (host.endsWith('.no')) return 'NO';
  if (host.endsWith('.nl')) return 'NL';
  if (host.endsWith('.pl')) return 'PL';
  if (host.endsWith('.fr')) return 'FR';
  if (host.endsWith('.si')) return 'SI';
  if (host.endsWith('.sk')) return 'SK';
  if (host.endsWith('.dk')) return 'DK';
  if (host.endsWith('.bg')) return 'BG';
  if (host.endsWith('.gr') || host.includes('carmedia24.gr')) return 'GR';
if (host.endsWith('.es')) return 'ES';
if (host.endsWith('.pt')) return 'PT';
if (host.endsWith('.it')) return 'IT';
if (host.endsWith('.fi')) return 'FI';
if (host.endsWith('.hu')) return 'HU';
if (host.endsWith('.at')) return 'AT';

  return 'DK';
}

function countrySelectDropdown() {
  const flagContainer = document.querySelector('#number-plate-form .input-wrapper');
  if (!flagContainer) return;
  const countryCodeElement = flagContainer.querySelector('.country-code');
  const countryDropdown = flagContainer.querySelector('.country-dropdown');
  const toggle = flagContainer.querySelector('.eu-flag-container');
  if (!toggle || !countryCodeElement || !countryDropdown) return;

  toggle.addEventListener('click', () => {
    countryDropdown.style.display = countryDropdown.style.display === 'block' ? 'none' : 'block';
    countryCodeElement.classList.toggle('open');
  });

  countryDropdown.querySelectorAll('li').forEach((item) => {
    item.addEventListener('click', () => {
      const code = (item.getAttribute('data-country') || '').toUpperCase();
      countryCodeElement.textContent = code === 'SI' ? 'SLO' : code;
      countryCodeElement.dataset.country = code;
      countryDropdown.style.display = 'none';
      countryCodeElement.classList.remove('open');
    });
  });

  const defaultCode = resolveCountryCode(countryCodeElement);
countryCodeElement.textContent = defaultCode === 'SI' ? 'SLO' : defaultCode;
countryCodeElement.dataset.country = defaultCode;
}

const PLATE_CACHE_TTL_MS = 1000 * 60 * 60 * 24 * 7;
function plateCacheKey(country, plate) { return `bm:plate:${country}:${plate}`; }
function readPlateCache(country, plate) {
  try {
    const raw = sessionStorage.getItem(plateCacheKey(country, plate));
    if (!raw) return null;
    const { ts, make, model } = JSON.parse(raw);
    if (!make || !model || (now() - ts) > PLATE_CACHE_TTL_MS) return null;
    return { make, model };
  } catch (_) { return null; }
}
function writePlateCache(country, plate, make, model) {
  try { sessionStorage.setItem(plateCacheKey(country, plate), JSON.stringify({ ts: now(), make, model })); } catch (_) {}
}

async function workerFetchSE(numberPlate, country = 'SE') {
  const uri = 'https://autumn-mud-ed7e.casper-3d6.workers.dev';

  const endpoint =
    `${uri}?number=${encodeURIComponent(numberPlate)}` +
    `&country=${encodeURIComponent(country)}`;

  const isSlowCountry = [
    'SE',
    'PL',
    'FR',
    'SI',
    'SK',
    'BG',
    'GR',
    'ES',
    'PT',
    'IT',
    'FI',
    'HU',
    'AT'
  ].includes(country);

  const perAttemptTimeout =
    country === 'SE'
      ? 14000
      : isSlowCountry
        ? 10000
        : 7000;

  const controller = new AbortController();

  const timeout = setTimeout(() => {
    controller.abort();
  }, perAttemptTimeout);

  try {
    const res = await fetch(endpoint, {
      signal: controller.signal,
      credentials: 'omit'
    });

    const text = await res.text();

    if (!res.ok) {
      const error = new Error(
        `http-${res.status}:${text.slice(0, 120)}`
      );

      error.status = res.status;
      throw error;
    }

    try {
      return JSON.parse(text);
    } catch (_) {
      throw new Error('invalid-json-response');
    }
  } finally {
    clearTimeout(timeout);
  }
}

async function logProductsShown(searchId, productsShown) {
  if (!searchId) return;

  try {
    await fetch('https://autumn-mud-ed7e.casper-3d6.workers.dev/log-products', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'omit',
      body: JSON.stringify({
        searchId,
        productsShown: Number.isFinite(Number(productsShown)) ? Number(productsShown) : 0
      })
    });
  } catch (_) {
    // Produktlogning må aldrig blokere kundeoplevelsen
  }
}



function getCustomerServiceConfig() {
  const host = location.hostname.replace(/^www\./, '').toLowerCase();

  const config = {
    "bilmedie.dk": {
      email: "info@bilmedie.dk",
      notFound: "Køretøjet blev ikke fundet.",
      error: "Der opstod en fejl ved opslaget.",
      contact: "Kontakt kundeservice:"
    },

    "bilmedie.se": {
      email: "info@bilmedie.se",
      notFound: "Fordonet hittades inte.",
      error: "Ett fel uppstod vid sökningen.",
      contact: "Kontakta kundtjänst:"
    },

    "bilmedie.no": {
      email: "info@bilmedie.no",
      notFound: "Kjøretøyet ble ikke funnet.",
      error: "Det oppstod en feil under oppslaget.",
      contact: "Kontakt kundeservice:"
    },

    "carmedia24.nl": {
      email: "info@carmedia24.nl",
      notFound: "Voertuig niet gevonden.",
      error: "Er is een fout opgetreden.",
      contact: "Neem contact op:"
    },

    "carmedia24.fr": {
      email: "info@carmedia24.fr",
      notFound: "Véhicule introuvable.",
      error: "Une erreur est survenue.",
      contact: "Contactez le service client :"
    },

    "carmedia24.sk": {
      email: "info@carmedia24.sk",
      notFound: "Vozidlo sa nenašlo.",
      error: "Počas vyhľadávania nastala chyba.",
      contact: "Kontaktujte zákaznícky servis:"
    },

    "carmedia24.pl": {
      email: "info@carmedia24.pl",
      notFound: "Nie znaleziono pojazdu.",
      error: "Wystąpił błąd podczas wyszukiwania.",
      contact: "Skontaktuj się z obsługą klienta:"
    }
  };

  return config[host] || {
    email: "info@bilmedie.dk",
    notFound: "Vehicle not found.",
    error: "Lookup failed.",
    contact: "Contact customer service:"
  };
}



async function handleOtherCountries(numberPlate, country = 'SE') {
  const productResultsContainer = document.getElementById('product-results');
  const carInfoContainer = document.getElementById('car-info');

  if (productResultsContainer) {
    productResultsContainer.innerHTML = `<div class="bm-loading" aria-busy="true"><span>${I18N.loading}</span><span class="bm-loading__spinner" aria-hidden="true"></span></div>`;
  }

  try {
    const data = await workerFetchSE(numberPlate, country);




   const make = data?.make || data?.vehicleMake || data?.Marque || data?.CarMake?.CurrentTextValue || data?.CarMake?.Description || '';
const model = data?.model || data?.vehicleModel || data?.Modell || data?.CarModel?.CurrentTextValue || data?.CarModel?.Description || '';
const lookupModel = cleanVehicleModelForProductLookup(model, make);
const displayModel = lookupModel || model;
const year = readVehicleYear(data);

  if (carInfoContainer) {
carInfoContainer.innerHTML = `<h4>${I18N.foundVehicle}: ${formatFoundVehicleHeading(make || I18N.unknown, displayModel || I18N.unknown, data)}</h4>`;}

if (make && model) {
  const productLookupModel = lookupModel || model;

  writePlateCache(country, numberPlate, make, productLookupModel);



  try {
    const matches = await showRelevantProducts(make, productLookupModel, {
  year,
  country,
  preserveHeading: true
});

await logProductsShown(data.searchId, Array.isArray(matches) ? matches.length : 0);

    if (!matches || !matches.length) {
      if (productResultsContainer) {
        productResultsContainer.innerHTML = `<p>${I18N.noVehicle}</p>`;
      }
    }

   } catch (productError) {
  console.error('Product lookup failed:', productError);

  await logProductsShown(data.searchId, 0);

  if (productResultsContainer) {
    productResultsContainer.innerHTML = `<p>${I18N.noVehicle}</p>`;
  }
}
} else {
  const cached = readPlateCache(country, numberPlate);

  if (cached) {
    if (productResultsContainer) {
      productResultsContainer.insertAdjacentHTML('afterbegin', `<p><small>${I18N.usingCache}</small></p>`);
    }

    await showRelevantProducts(cached.make, cached.model);
  } else if (productResultsContainer) {
    productResultsContainer.innerHTML = `<p>${I18N.noVehicle}</p>`;
  }
}


  } catch (error) {
    const cached = readPlateCache(country, numberPlate);
    if (cached) {
      if (productResultsContainer) productResultsContainer.innerHTML = `<p>${I18N.usingCache}</p>`;
      await showRelevantProducts(cached.make, cached.model);
      return;
    }
    const support = getCustomerServiceConfig();
const code = Number(error?.status || error?.code);

if (productResultsContainer) {
  const message = code === 404
    ? support.notFound
    : support.error;

  productResultsContainer.innerHTML = `
    <p>${message}</p>

    <p>
      ${support.contact}<br>
      <a href="mailto:${support.email}">
        <strong>${support.email}</strong>
      </a>
    </p>
  `;
}

  }
}

function setupNumberPlateForm() {
  const form = document.getElementById('number-plate-form');
  if (!form) return;

  const productResultsContainer = document.getElementById('product-results');
  const renderError = (msg, sub) => {
    if (productResultsContainer) productResultsContainer.innerHTML = `<p>${msg}</p>${sub ? `<small style="opacity:.7">${sub}</small>` : ''}`;
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const numberPlateInput = document.getElementById('numberPlate');
    const plate = (numberPlateInput?.value || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');

CURRENT_LOOKUP_PLATE = plate;

    if (!plate) {
      renderError(I18N.enterPlate);
      return;
    }

    const badge = form.querySelector('.country-code');
    const country = resolveCountryCode(badge);

   try {
 

if (
  [
    'DK',
    'SE',
    'NO',
    'NL',
    'PL',
    'FR',
    'SI',
    'SK',
    'BG',
    'GR',
    'ES',
    'PT',
    'IT',
    'FI',
    'HU',
    'AT'
  ].includes(country)
) {
  await handleOtherCountries(plate, country);
  return;
}

  renderError(I18N.countryUnsupported);
} catch (_) {
  renderError(I18N.lookupError);
}
  });
}

const carSelectorFormApp = {
  async init() {
    this.container = document.querySelector('.car-selector-form');
    if (!this.container) return;

    this.makesSelect = this.container.querySelector('#car-makes');
    this.modelsSelect = this.container.querySelector('#car-models');
    this.form = this.container;

    if (!this.makesSelect || !this.modelsSelect || !this.form) return;

    this.setupEventListeners();
    await this.populateMakesDropdown();
  },

  setupEventListeners() {
    this.makesSelect.addEventListener('change', this.handleMakeChange.bind(this));
    this.modelsSelect.addEventListener('change', (e) => e.target.classList.add('selected'));
    this.form.addEventListener('submit', this.handleFormSubmission.bind(this));
  },

  cleanOptionText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/,+$/g, '')
      .trim();
  },

  canonicalText(value) {
    return this.cleanOptionText(value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  },

  canonicalMakeKey(value) {
    const key = this.canonicalText(value);

    if (!key) return '';

    if (key === 'vw') return 'volkswagen';
    if (key === 'volks wagen') return 'volkswagen';
    if (key === 'volkswagen') return 'volkswagen';

    if (key === 'citroen') return 'citroen';

    if (key === 'mercedes') return 'mercedes-benz';
    if (key === 'mercedes benz') return 'mercedes-benz';
    if (key === 'mercedes-benz') return 'mercedes-benz';

    if (key === 'skoda') return 'skoda';
    if (key === 'skoda auto') return 'skoda';

    if (key === 'land rover') return 'land rover';
    if (key === 'range rover') return 'land rover';

    if (key === 'alfa romeo') return 'alfa romeo';

    return key;
  },

  displayMakeLabel(value) {
    const key = this.canonicalMakeKey(value);

    const labels = {
      'volkswagen': 'Volkswagen',
      'citroen': 'Citroën',
      'mercedes-benz': 'Mercedes-Benz',
        'mercedes benz': 'Mercedes-Benz',
      'skoda': 'Skoda',
      'land rover': 'Land Rover',
      'alfa romeo': 'Alfa Romeo',
      'audi': 'Audi',
      'bmw': 'BMW',
      'fiat': 'Fiat',
      'ford': 'Ford',
      'opel': 'Opel',
      'peugeot': 'Peugeot',
      'renault': 'Renault',
      'seat': 'Seat',
      'toyota': 'Toyota',
      'nissan': 'Nissan',
      'hyundai': 'Hyundai',
      'kia': 'Kia',
      'volvo': 'Volvo',
      'tesla': 'Tesla',
      'mazda': 'Mazda',
      'honda': 'Honda',
      'mitsubishi': 'Mitsubishi',
      'suzuki': 'Suzuki',
      'dacia': 'Dacia',
      'mini': 'Mini'
    };

    if (labels[key]) return labels[key];

    return this.cleanOptionText(value)
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  },

  
dedupeMakes(items) {
  const seen = new Map();

 const blockedMakes = new Set([
  'daf',
  'mazada',
  'jimny',
  'mazdav',
  'proace',
  'scania'
]);

  (items || []).forEach((item) => {
    let rawLabel = '';
    let rawValue = '';

    if (typeof item === 'string') {
      rawLabel = this.cleanOptionText(item);
      rawValue = this.cleanOptionText(item);
    } else {
      rawLabel = this.cleanOptionText(
        item.label ||
        item.value ||
        item.make ||
        item.name ||
        item.title
      );

      rawValue = this.cleanOptionText(
        item.value ||
        item.label ||
        item.make ||
        item.name ||
        item.title
      );
    }

    if (!rawLabel && !rawValue) return;

    const labelSource = rawLabel || rawValue;
    const valueSource = rawValue || rawLabel;

    // Fjern kombinationsmærker som "Suzuki / Opel", "Citroën / Peugeot" osv.
    if (
      labelSource.includes('/') ||
      valueSource.includes('/') ||
      labelSource.includes('|') ||
      valueSource.includes('|') ||
      labelSource.includes(';') ||
      valueSource.includes(';')
    ) {
      return;
    }

    let key = this.canonicalMakeKey(labelSource);

    key = key
      .replace(/\s+/g, ' ')
      .replace(/-/g, ' ')
      .trim();

    if (key === 'citroen' || key === 'citro n') key = 'citroen';
    if (key === 'vw' || key === 'volks wagen') key = 'volkswagen';
    if (key === 'mercedes' || key === 'mercedes benz') key = 'mercedes-benz';

    // Fjern kendte fejlmærker
    if (blockedMakes.has(key)) return;

    if (!key) return;

    if (!seen.has(key)) {
      seen.set(key, {
        value: valueSource,
        label: this.displayMakeLabel(labelSource)
      });
    }
  });

  return Array.from(seen.values()).sort((a, b) =>
    String(a.label).localeCompare(String(b.label), 'da')
  );
},

dedupeModels(items) {
  const seen = new Map();

  (items || []).forEach((item) => {
    let rawLabel = '';
    let rawValue = '';

    if (typeof item === 'string') {
      rawLabel = this.cleanOptionText(item);
      rawValue = this.cleanOptionText(item);
    } else {
      rawLabel = this.cleanOptionText(
        item.label ||
        item.value ||
        item.model ||
        item.name ||
        item.title
      );

      rawValue = this.cleanOptionText(
        item.value ||
        item.label ||
        item.model ||
        item.name ||
        item.title
      );
    }

    if (!rawLabel || !rawValue) return;

    const key = this.canonicalText(rawLabel);

    if (!key) return;

    if (!seen.has(key)) {
      seen.set(key, {
        value: rawValue,
        label: rawLabel
      });
    }
  });

  return Array.from(seen.values()).sort((a, b) =>
    String(a.label).localeCompare(String(b.label), 'da')
  );
},


 getMakePlaceholder() {
  return this.makesSelect.dataset.placeholder || I18N.labelMake;
},

 getModelPlaceholder() {
  return this.modelsSelect.dataset.placeholder || I18N.labelModel;
},

  async populateMakesDropdown() {
  try {
    const json = await apiJson(
      `${PRODUCTS_API_URL}?facet=makes`
    );

    if (json.success && Array.isArray(json.data)) {
      const uniqueMakes = new Map();

      for (const rawMake of json.data) {
        const make = String(rawMake || '').trim();

        if (!make) {
          continue;
        }

        const key = make
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();

        if (!uniqueMakes.has(key)) {
          uniqueMakes.set(key, make);
        }
      }

      const makes = Array.from(
        uniqueMakes.values()
      ).sort((a, b) =>
       a.localeCompare(b, 'en', {
  sensitivity: 'base',
  numeric: true

        })
      );

      this.makesSelect.innerHTML = '';

      const placeholderOption =
        document.createElement('option');

      placeholderOption.value = '';
      placeholderOption.textContent =
        this.getMakePlaceholder();

      placeholderOption.disabled = true;
      placeholderOption.selected = true;

      this.makesSelect.appendChild(
        placeholderOption
      );

      for (const make of makes) {
        const option =
          document.createElement('option');

        option.value = make;
        option.textContent = make;

        this.makesSelect.appendChild(option);
      }
    }
  } catch (error) {
    console.error(
      'Failed to load makes from backend:',
      error
    );
  }
},

  async handleMakeChange(e) {
    const makeValue = e.target.value;

    if (!makeValue) {
      this.modelsSelect.innerHTML = `<option disabled selected value="">${this.getModelPlaceholder()}</option>`;
      this.modelsSelect.disabled = true;
      return;
    }

    this.modelsSelect.disabled = true;
    this.modelsSelect.classList.remove('selected');

    this.modelsSelect.innerHTML = `<option disabled selected value="">${
      I18N.loading
    }</option>`;

    try {
      const qp = new URLSearchParams({ facet: 'models', make: makeValue });
      const json = await apiJson(`${PRODUCTS_API_URL}?${qp.toString()}`);

      if (json.success && Array.isArray(json.data)) {
        const cleanedModels = this.dedupeModels(json.data);

        const options = [
          `<option disabled selected value="">${this.getModelPlaceholder()}</option>`
        ].concat(
          cleanedModels.map((item) => `<option value="${item.value}">${item.label}</option>`)
        );

        this.modelsSelect.innerHTML = options.join('');
        this.modelsSelect.disabled = cleanedModels.length === 0;
      } else {
        this.modelsSelect.innerHTML = `<option disabled selected value="">${
   I18N.noVehicle
        }</option>`;

        this.modelsSelect.disabled = true;
      }
    } catch (error) {
      console.error('Failed to load models:', error);

      this.modelsSelect.innerHTML = `<option disabled selected value="">${
   I18N.lookupError
      }</option>`;

      this.modelsSelect.disabled = true;
    }
  },

  async handleFormSubmission(e) {
    e.preventDefault();

    const selectedMake = this.makesSelect.value;
    const selectedModel = this.modelsSelect.value;

    if (!selectedMake || !selectedModel) {
      const productResults = document.getElementById('product-results');

      if (productResults) {
        productResults.innerHTML = `<p>${
          IS_EN ? 'Please select both make and model' :
          IS_SE ? 'Välj både märke och modell' :
          'Vælg både mærke og model'
        }</p>`;
      }

      return;
    }

    const carInfoContainer = document.getElementById('car-info');
    const productResultsContainer = document.getElementById('product-results');

    if (productResultsContainer) {
      productResultsContainer.innerHTML = `<div class="bm-loading" aria-busy="true"><span>${I18N.loading}</span><span class="bm-loading__spinner" aria-hidden="true"></span></div>`;
    }

    try {
      const qp = new URLSearchParams({ make: selectedMake, model: selectedModel });
      const json = await apiJson(`${PRODUCTS_API_URL}?${qp.toString()}`);

      if (json.success && Array.isArray(json.data) && json.data.length > 0) {
        const firstProduct = json.data[0];

        const yearRange = formatYearRange(firstProduct.year_from, firstProduct.year_to);
        const makeTitle = this.displayMakeLabel(firstProduct.make || selectedMake);
        const modelTitle = this.cleanOptionText(firstProduct.model || selectedModel);
        const heading = `${makeTitle} ${modelTitle} ${yearRange}`.trim();

        if (carInfoContainer) {
          carInfoContainer.innerHTML = `<h4>${heading}</h4>`;
        }

        if (productResultsContainer) {
          productResultsContainer.innerHTML = renderVehicleProducts(json.data);
        }
      } else {
        if (carInfoContainer) {
          carInfoContainer.innerHTML = `<h4>${I18N.noVehicle}</h4>`;
        }

        if (productResultsContainer) {
          productResultsContainer.innerHTML = `<p>${I18N.noVehicle}</p>`;
        }
      }
    } catch (error) {
      console.error('Product fetch failed:', error);

      if (carInfoContainer) {
        carInfoContainer.innerHTML = '';
      }

      if (productResultsContainer) {
        productResultsContainer.innerHTML = `<p>${I18N.lookupError}</p>`;
      }
    }
  }
};



function overrideFRLocale() {
  try {
    if (typeof Shopify !== 'undefined' && Shopify.locale === 'fr') {
      const el = document.querySelector('.eu-flag-container .country-code');
      if (el) {
        el.dataset.country = 'FR';
        el.textContent = 'FR';
      }
    }
  } catch (_) {}
}

document.addEventListener('DOMContentLoaded', async () => {
  try { ensureLoaderStyles(); } catch (_) {}
  try { countrySelectDropdown(); } catch (_) {}
  try { setupNumberPlateForm(); } catch (_) {}
  try { await carSelectorFormApp.init(); } catch (_) {}
  try { overrideFRLocale(); } catch (_) {}
});
